<template>
  <div class="score-page">
    <login-after-head-search></login-after-head-search>
    <div class="container submit-container">
      <div class="pay-title">
        <router-link to="/score">积分商城</router-link><span class="arrow"></span>确认兑换
      </div>
      <section class="submit-section">
        <div class="section-title fc-bet">
          <span>选择收货地址</span>
          <router-link to="/address">管理收货地址</router-link>
        </div>
        <div v-loading="addressLoading" class="address-grid">
          <div
            v-for="(address, index) in addressList"
            :key="address.id"
            class="address-item"
            :class="{ active: selectedAddressIndex === index }"
            @click="selectAddress(index)"
          >
            <div>
              <strong>{{ address.realName || '--' }}</strong>
              <span>{{ address.phone || '--' }}</span>
            </div>
            <p>{{ address.province }}{{ address.city }}{{ address.district }}{{ address.detail }}</p>
          </div>
          <div v-if="!addressLoading && addressList.length === 0" class="empty-address">
            暂无收货地址，请先添加地址
          </div>
        </div>
      </section>

      <section v-loading="orderLoading" class="submit-section">
        <div class="section-title">确认兑换商品</div>
        <div v-if="orderInfo.cartInfo.length" class="goods-list">
          <div v-for="(item, index) in orderInfo.cartInfo" :key="index" class="goods-row">
            <img :src="productImage(item)" :alt="productName(item)">
            <div class="goods-info">
              <strong>{{ productName(item) }}</strong>
              <span>{{ productSku(item) }}</span>
            </div>
            <span class="goods-price">{{ isSeckillItem(item) ? '秒杀' : '积分' }}{{ itemPointPrice(item) }} × {{ item.cartNum }}</span>
            <strong class="goods-subtotal">{{ itemPointPrice(item) * item.cartNum }} 积分</strong>
          </div>
        </div>
        <div v-else-if="!orderLoading" class="empty-address">兑换商品不存在，请返回积分商城重试</div>
<!--        <div class="remark-row">-->
<!--          <label for="integral-order-mark">订单备注</label>-->
<!--          <textarea id="integral-order-mark" v-model="mark" maxlength="200" placeholder="请输入订单备注"></textarea>-->
<!--        </div>-->
      </section>

      <section v-if="orderInfo.cartInfo.length" class="summary-section">
        <div>商品数量：{{ totalNum }}</div>
        <div aria-live="polite">
          兑换积分：<strong v-if="pointsReady">{{ payablePoints }} 积分</strong>
          <span v-else>{{ pointsLoading ? '计算中...' : '待计算' }}</span>
        </div>
        <button v-if="pointsError" type="button" :disabled="pointsLoading" @click="calculatePoints">
          重新计算
        </button>
        <button type="button" :disabled="!canSubmit" @click="submitOrder">
          {{ submitting ? '提交中...' : '提交兑换' }}
        </button>
      </section>
    </div>
    <i-footer></i-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import { getAddressData } from '@/api/user'
import { computedOrder, confirmOrder, createOrder } from '@/api/order'

export default {
  name: 'IntegralSubmit',
  data () {
    return {
      cartId: '',
      addressList: [],
      selectedAddressIndex: 0,
      orderInfo: {
        addressInfo: null,
        cartInfo: [],
        orderKey: ''
      },
      computedPriceInfo: {
        payIntegral: 0,
        paySecKillIntegral: 0
      },
      mark: '',
      addressLoading: true,
      orderLoading: true,
      pointsLoading: false,
      pointsReady: false,
      pointsError: false,
      pointsRequestId: 0,
      submitting: false
    }
  },
  computed: {
    canSubmit () {
      return this.pointsReady && !this.pointsLoading && !this.orderLoading && !this.submitting &&
        !!this.selectedAddress && !!this.orderInfo.orderKey && this.orderInfo.cartInfo.length > 0
    },
    selectedAddress () {
      return this.addressList[this.selectedAddressIndex] || null
    },
    totalNum () {
      return this.orderInfo.cartInfo.reduce((total, item) => total + Number(item.cartNum || 0), 0)
    },
    payablePoints () {
      const seckillPoints = Number(this.computedPriceInfo.paySecKillIntegral || 0)
      return seckillPoints > 0 ? seckillPoints : Number(this.computedPriceInfo.payIntegral || 0)
    }
  },
  mounted () {
    this.cartId = this.$route.query.cartId || ''
    if (!this.cartId) {
      this.$message.warning('兑换信息已失效，请重新选择商品')
      this.$router.replace('/score')
      return
    }
    this.loadAddresses().then(() => this.loadOrderInfo())
  },
  methods: {
    loadAddresses () {
      return getAddressData().then(res => {
        this.addressList = Array.isArray(res.data) ? res.data : []
        if (!this.addressList.length) {
          this.$message.warning('请先添加收货地址')
          this.$router.replace('/address')
          return
        }
        const defaultIndex = this.addressList.findIndex(item => item.isDefault)
        this.selectedAddressIndex = defaultIndex >= 0 ? defaultIndex : 0
      }).catch(error => {
        this.$message.warning((error && error.msg) || '收货地址加载失败，请重试')
      }).finally(() => {
        this.addressLoading = false
      })
    },
    loadOrderInfo () {
      if (!this.addressList.length) {
        this.orderLoading = false
        return Promise.resolve()
      }
      return confirmOrder({ cartId: this.cartId }).then(res => {
        this.orderInfo = Object.assign(this.orderInfo, res.data || {})
        if (this.orderInfo.addressInfo) {
          const addressIndex = this.addressList.findIndex(item => item.id === this.orderInfo.addressInfo.id)
          if (addressIndex >= 0) this.selectedAddressIndex = addressIndex
        }
        return this.calculatePoints()
      }).catch(error => {
        this.$message.warning((error && error.msg) || '兑换信息加载失败，请重试')
      }).finally(() => {
        this.orderLoading = false
      })
    },
    selectAddress (index) {
      if (this.submitting) return
      this.selectedAddressIndex = index
      if (this.orderInfo.orderKey) this.calculatePoints()
    },
    calculatePoints () {
      if (this.submitting) return Promise.resolve()
      const requestId = ++this.pointsRequestId
      this.pointsReady = false
      this.pointsError = false
      this.pointsLoading = false
      if (!this.orderInfo.orderKey || !this.selectedAddress) return Promise.resolve()
      this.pointsLoading = true
      return computedOrder(this.orderInfo.orderKey, {
        addressId: this.selectedAddress.id,
        couponId: '0',
        payType: 'integral',
        shippingType: '1',
        useIntegral: ''
      }).then(res => {
        if (requestId !== this.pointsRequestId) return
        const result = res.data && res.data.result
        const validPoints = value => (typeof value === 'number' || typeof value === 'string') &&
          String(value).trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0
        if (res.status !== 200 || !result || !validPoints(result.payIntegral) ||
          !validPoints(result.paySecKillIntegral)) {
          throw new Error(res.msg || '积分计算结果异常，请重试')
        }
        this.computedPriceInfo = result
        this.pointsReady = true
      }).catch(error => {
        if (requestId !== this.pointsRequestId) return
        this.pointsError = true
        this.$message.warning((error && (error.msg || error.message)) || '积分计算失败，请重试')
      }).finally(() => {
        if (requestId === this.pointsRequestId) this.pointsLoading = false
      })
    },
    productImage (item) {
      const product = item.productInfo || {}
      const attrInfo = product.attrInfo || {}
      return attrInfo.image || product.image || require('../assets/noll.png')
    },
    productName (item) {
      const product = item.productInfo || {}
      return product.storeName || '--'
    },
    productSku (item) {
      const product = item.productInfo || {}
      const attrInfo = product.attrInfo || {}
      return attrInfo.skuName || product.storeInfo || '--'
    },
    isSeckillItem (item) {
      return Number(item && item.seckillId) > 0
    },
    itemPointPrice (item) {
      const product = item.productInfo || {}
      const attrInfo = product.attrInfo || {}
      if (this.isSeckillItem(item)) {
        return Number(attrInfo.seckillIntegral || 0)
      }
      return Number(attrInfo.integral || product.integral || 0)
    },
    submitOrder () {
      if (!this.canSubmit) return
      this.submitting = true
      createOrder(this.orderInfo.orderKey, {
        addressId: this.selectedAddress.id,
        bargainId: '0',
        combinationId: '0',
        couponId: '0',
        from: 'pc',
        isChannel: '',
        mark: this.mark,
        orderType: 1,
        payType: 'integral',
        phone: this.selectedAddress.phone,
        pinkId: '0',
        realName: this.selectedAddress.realName,
        seckillId: '0',
        shippingType: '1',
        storeId: '0',
        useIntegral: ''
      }).then(res => {
        if (res.status !== 200) throw new Error(res.msg || '积分订单提交失败')
        this.$message.success('积分订单提交成功')
        this.$router.push({ path: '/integralOrders', query: { type: -1 } })
      }).catch(error => {
        this.$message.warning((error && error.msg) || '积分订单提交失败，请重试')
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.submit-container {
  padding-bottom: 30px;
}
.pay-title {
  height: 65px;
  display: flex;
  align-items: center;
  color: #666;
  font-size: 16px;
}
.pay-title a {
  color: #57aca7;
}
.pay-title .arrow {
  width: 7px;
  height: 12px;
  margin: 0 12px;
  background: url('../assets/company-default.png') no-repeat -25px -126px;
}
.submit-section {
  margin-bottom: 20px;
  padding: 24px;
  border: 1px solid #eee;
  background: #fff;
}
.section-title {
  padding-bottom: 18px;
  border-bottom: 1px solid #eee;
  color: #333;
  font-size: 18px;
}
.section-title a {
  color: #57aca7;
  font-size: 14px;
}
.address-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  padding-top: 20px;
}
.address-item {
  min-height: 88px;
  padding: 16px;
  border: 1px solid #ddd;
  cursor: pointer;
}
.address-item.active {
  border-color: #57aca7;
  background: #f7fbfa;
}
.address-item strong {
  margin-right: 20px;
  color: #333;
}
.address-item p {
  margin-top: 12px;
  color: #666;
  line-height: 1.5;
}
.empty-address {
  grid-column: 1 / -1;
  padding: 70px 0;
  color: #999;
  text-align: center;
}
.goods-list {
  padding-top: 10px;
}
.goods-row {
  display: flex;
  align-items: center;
  gap: 18px;
  min-height: 92px;
  border-bottom: 1px solid #f1f1f1;
}
.goods-row img {
  width: 72px;
  height: 72px;
  object-fit: contain;
}
.goods-info {
  flex: 1;
}
.goods-info strong,
.goods-info span {
  display: block;
}
.goods-info strong {
  color: #333;
}
.goods-info span {
  margin-top: 8px;
  color: #999;
  font-size: 12px;
}
.goods-price,
.goods-subtotal {
  width: 150px;
  color: #57aca7;
  text-align: right;
}
.goods-subtotal {
  color: #e43d33;
}
.remark-row {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  padding-top: 20px;
}
.remark-row label {
  width: 70px;
  padding-top: 8px;
  color: #666;
}
.remark-row textarea {
  width: 360px;
  height: 62px;
  padding: 8px;
  border: 1px solid #ddd;
  resize: vertical;
}
.summary-section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 30px;
  padding: 22px 24px;
  background: #fff;
  border: 1px solid #eee;
  color: #666;
}
.summary-section strong {
  color: #e43d33;
  font-size: 22px;
}
.summary-section button {
  width: 140px;
  height: 42px;
  border: 0;
  background: #57aca7;
  color: #fff;
  cursor: pointer;
}
.summary-section button:disabled {
  cursor: not-allowed;
  opacity: .55;
}
</style>
